import React from "react";
import { Routes, Route } from "react-router-dom";
import Forgot from "../components/auth/Forgot";
import SignIn from "../components/auth/SignIn";
import LaunchSignInAlt from "../components/auth/LaunchSignInAlt";

export default function PublicRoutes() {
  return (
    <Routes>
      <Route exact path="/" element={<SignIn />} />
      <Route exact path="/alt-sign-in" element={<LaunchSignInAlt />} />
      <Route path="/forgot" element={<Forgot />} />
    </Routes>
  );
}
